import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useRecoilState } from 'recoil';
import { userAtom } from '../core/config/atoms';

import { AnimatePresence, motion } from "framer-motion";

import { User, LibraryBig, Building2 } from 'lucide-react';

import PanelDev from '../panels/dev/PanelDev';

import PanelSettings from 'panels/settings/PanelSettings';
import PanelMarLang from 'panels/settings/PanelMarLang';
import PanelMarCountry from 'panels/settings/PanelMarCountry';
import PanelMarPack from 'panels/settings/PanelMarPack';
import PanelMarDisbilitie from 'panels/settings/PanelMarDisbilitie';
import PanelMarHelp from 'panels/settings/PanelMarHelp';

export default function LayoutSetting() {

    const [userData, setUserData] = useRecoilState(userAtom);

    const [isOpen, setIsOpen] = useState(true);

    const { page } = useParams();

    const navigate = useNavigate();

    const itemVariants = {
        closed: { opacity: 0 },
        open: { opacity: 1 }
    };

    const changeNav = (link) => {
        navigate(`/home/${link}`);
        setIsOpen(true);
    }

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    }

    return (
        <>
            <AnimatePresence>
                {
                    isOpen && <motion.div initial={{ width: 0 }} animate={{ width: '16rem' }} exit={{ width: 0, transition: { delay: 0.2, duration: 0.3 } }} className="w-56 lg:w-64 h-screen bg-slate-100">
                        <motion.h1 initial="closed" animate="open" exit="closed" variants={itemVariants} className="text-2xl font-medium px-2 mx-2 py-1 my-2 rounded">Settings</motion.h1>
                        <motion.div initial="closed" animate="open" exit="closed" variants={itemVariants}>
                            <p className='text-sm uppercase px-1 mx-4 py-1'>{userData.user.fname}{userData.user.lname === "NA" ? "" : ` ${userData.user.lname}`}</p>
                        </motion.div>
                        <motion.ul initial="closed" animate="open" exit="closed" variants={itemVariants} className="w-64 flex flex-col items-start">
                            <li className={`w-56 cursor-pointer text-base px-1 mx-4 py-1 my-1 hover:bg-gray-200 rounded flex items-center ${page === 'setting' ? 'text-prime font-medium' : 'text-black'}`} onClick={() => { changeNav('setting') }}>
                                <User size={20} className='mr-2' /> User Profile
                            </li>
                        </motion.ul>
                        {
                            userData.type === "admin" && <motion.div initial="closed" animate="open" exit="closed" variants={itemVariants}>
                                <p className='text-sm uppercase px-1 mx-4 py-1'>MASTERS</p>
                            </motion.div>
                        }
                        {
                            userData.type === "admin" && < motion.ul initial="closed" animate="open" exit="closed" variants={itemVariants} className="w-64 flex flex-col items-start">
                                <li className={`w-56 cursor-pointer text-base px-1 mx-4 py-1 my-1 hover:bg-gray-200 rounded flex items-center ${page === 'marLang' ? 'text-prime font-medium' : 'text-black'}`} onClick={() => { changeNav('marLang') }}>
                                    <LibraryBig size={20} className='mr-2' /> Language Master
                                </li>
                                <li className={`w-56 cursor-pointer text-base px-1 mx-4 py-1 my-1 hover:bg-gray-200 rounded flex items-center ${page === 'marCountry' ? 'text-prime font-medium' : 'text-black'}`} onClick={() => { changeNav('marCountry') }}>
                                    <LibraryBig size={20} className='mr-2' /> Country Master
                                </li>
                                <li className={`w-56 cursor-pointer text-base px-1 mx-4 py-1 my-1 hover:bg-gray-200 rounded flex items-center ${page === 'marPackage' ? 'text-prime font-medium' : 'text-black'}`} onClick={() => { changeNav('marPackage') }}>
                                    <LibraryBig size={20} className='mr-2' /> Package Master
                                </li>
                                <li className={`w-56 cursor-pointer text-base px-1 mx-4 py-1 my-1 hover:bg-gray-200 rounded flex items-center ${page === 'marDisbilitie' ? 'text-prime font-medium' : 'text-black'}`} onClick={() => { changeNav('marDisbilitie') }}>
                                    <LibraryBig size={20} className='mr-2' /> Condition Master
                                </li>
                                <li className={`w-56 cursor-pointer text-base px-1 mx-4 py-1 my-1 hover:bg-gray-200 rounded flex items-center ${page === 'marHelp' ? 'text-prime font-medium' : 'text-black'}`} onClick={() => { changeNav('marHelp') }}>
                                    <LibraryBig size={20} className='mr-2' /> Help Master
                                </li>
                            </motion.ul>
                        }
                    </motion.div>
                }
            </AnimatePresence >
            <div className='h-screen w-full'>
                {
                    (() => {
                        switch (page) {
                            case 'setting':
                                return (<PanelSettings onToggle={toggleMenu} />);
                            case 'marLang':
                                return (<PanelMarLang onToggle={toggleMenu} />);
                            case 'marCountry':
                                return (<PanelMarCountry onToggle={toggleMenu} />);
                            case 'marPackage':
                                return (<PanelMarPack onToggle={toggleMenu} />);
                            case 'marDisbilitie':
                                return (<PanelMarDisbilitie onToggle={toggleMenu} />);
                            case 'marHelp':
                                return (<PanelMarHelp onToggle={toggleMenu} />);
                            default:
                                return (<PanelDev />);
                        }
                    })()
                }
            </div>
        </>
    )
}
